var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHardDrive = function SvgIconHardDrive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.375 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 5.75A1.75 1.75 0 0 0 1.25 7.5v9c0 .966.784 1.75 1.75 1.75h18a1.75 1.75 0 0 0 1.75-1.75v-9A1.75 1.75 0 0 0 21 5.75zm.25 10.5v-8.5h17.5v8.5z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconHardDrive;